export const exampleCreator = {
  name: 'Cynthia Tang',
  username: 'cynnthiamakes',
  location: 'Singapore',
  avatarUrl: '/profile_pic_female_1.jpeg',
  coverUrl: '/mock_banner_1.jpeg',
  niches: ['Beauty', 'Lifestyle', 'Cafes', 'UGC'],
  stats: [
    { platform: 'Instagram', value: '8.4K' },
    { platform: 'TikTok', value: '12.7K' },
  ],
  avgViews: '18K',
  verifiedCampaigns: 14,
  featuredCampaigns: ['☕ Summer Coffee Launch', '💆🏻‍♀️ GlowLab Skincare Routine', '📅 Marina Bay Weekend Guide'],
  frequentCollaborators: [
    { name: 'Erin Lim', role: 'Photographer', avatarUrl: '/profile_pic_female_2.jpeg' },
    { name: 'Chloe Ng', role: 'Video Editor', avatarUrl: '/profile_pic_female_3.png' },
    { name: 'Ryan Koh', role: 'Creator', avatarUrl: '/profile_pic_male_1.jpeg' },
  ],
};

export const heroCollaborators = [
  { name: 'Erin Lim', role: 'Photographer', avatarUrl: '/profile_pic_female_2.jpeg' },
  { name: 'Chloe Ng', role: 'Video Editor', avatarUrl: '/profile_pic_female_3.png' },
  { name: 'Ryan Koh', role: 'Creator', avatarUrl: '/profile_pic_male_1.jpeg' },
];

export const howItWorksSteps = [
  {
    step: 1,
    icon: 'AssignmentTurnedInOutlined',
    title: 'Join the opportunity list',
    description: 'Tell us where to send new UGC briefs as they become available.',
  },
  {
    step: 2,
    icon: 'PersonOutlineOutlined',
    title: 'Build your CreatorCV',
    description: 'Add your niches, location, audience insights, and contact details in one professional profile.',
  },
  {
    step: 3,
    icon: 'CollectionsOutlined',
    title: 'Show brands what you can do',
    description: 'Add paid work, gifted campaigns, or personal UGC samples that prove your fit for a brief.',
  },
  {
    step: 4,
    icon: 'BarChartOutlined',
    title: 'Receive relevant briefs',
    description: 'We’ll notify you when UGC opportunities become available so you can decide which ones fit.',
  },
];

export const campaignExample = {
  name: 'Summer Coffee Launch',
  brand: 'Common Ground Coffee',
  date: 'Jun 2026',
  deliverables: ['2 Instagram Reels', '4 Instagram Stories', '1 TikTok video'],
  results: '142K combined views · 6.8% engagement rate',
  contentLinks: 2,
  collaborators: [
    { name: 'Maya Tan', role: 'Creator', avatarUrl: '/profile_pic_female_1.jpeg' },
    { name: 'Erin Lim', role: 'Photographer', avatarUrl: '/profile_pic_female_2.jpeg' },
    { name: 'Chloe Ng', role: 'Video Editor', avatarUrl: '/profile_pic_female_3.png' },
  ],
  verifiedCount: 3,
};

export const benefits = [
  {
    icon: 'WorkspacePremiumOutlined',
    title: 'Find opportunities in one place',
    description: 'Hear about new UGC briefs without relying on scattered posts, group chats, or chance discovery.',
  },
  {
    icon: 'AssignmentTurnedInOutlined',
    title: 'Be ready to pitch',
    description: 'Keep your niches, audience, UGC samples, and past campaigns in one profile you can share quickly.',
  },
  {
    icon: 'GroupsOutlined',
    title: 'Open to emerging creators',
    description: 'You do not need to be a full-time influencer. Strong personal UGC samples can show what you can create.',
  },
];

export const faqs = [
  {
    question: 'How do CreatorCV UGC opportunities work?',
    answer:
      'Join the opportunity list and we’ll email you when relevant UGC briefs become available. Availability varies, and each brief may have its own location, niche, or deliverable requirements.',
  },
  {
    question: 'Do I need a CreatorCV profile to join the opportunity list?',
    answer:
      'No. You can join with just your email. Creating a free CreatorCV helps you keep your UGC samples, niches, audience insights, and past work ready to share with brands.',
  },
  {
    question: 'Is CreatorCV free?',
    answer: 'Yes. Creating your profile, adding campaigns, and tagging collaborators is free.',
  },
  {
    question: 'Do I need to be a full-time creator?',
    answer:
      'No. CreatorCV is built for creators of any size, including part-time and emerging creators looking for their first paid UGC opportunity.',
  },
  {
    question: 'Can I add unpaid or gifted campaigns?',
    answer: 'Yes. You can add paid campaigns, gifted campaigns, UGC projects, event coverage, and personal projects.',
  },
  // {
  //   question: 'What if my collaborator does not have an account?',
  //   answer: 'You can tag them by name and invite them by email or link. They can claim the campaign and create their own profile.',
  // },
  // {
  //   question: 'How are collaborations verified?',
  //   answer:
  //     'When you tag a collaborator, they receive an invite to confirm their role on the campaign. Once confirmed, the collaboration is marked verified on both profiles.',
  // },
  {
    question: 'Can I share my profile with brands?',
    answer: 'Yes. Every CreatorCV profile has a shareable link you can send directly to brands or include in outreach emails.',
  },
  {
    question: 'Does CreatorCV replace my link-in-bio page?',
    answer:
      'CreatorCV can include your social and content links, but it is designed primarily as your professional creator identity, portfolio, and verified work history.',
  },
];
